<template>
  <div>
    <div class="text-3xl mb-8">Stammdaten</div>

    <!--- ROW ---->
    <div class="flex flex-wrap -mx-2">
      <div class="w-full md:w-1/2 px-2 mb-6">
        <div class="mb-2">Firmenname: *</div>
        <v-input v-model="agencyInput.company_name" name="company_name" rules="required"></v-input>
      </div>

      <div class="w-full md:w-1/2 px-2 mb-6">
        <div class="mb-2">Vertretungsberechtigter: *</div>
        <v-input v-model="agencyInput.authority_name" name="authority_name" rules="required"></v-input>
      </div>

      <div class="w-full md:w-1/2 px-2 mb-6">
        <div class="mb-2">Adresse: *</div>
        <v-input v-model="agencyInput.street" name="street" rules="required" vv-as="Adresse"></v-input>
      </div>

      <div class="w-1/2 px-2 mb-6">
        <div class="mb-2">Stadt: *</div>
        <v-input v-model="agencyInput.city" name="city" rules="required"></v-input>
      </div>

      <div class="w-1/2 px-2 mb-6">
        <div class="mb-2">Postleitzahl: *</div>

        <v-input v-model="agencyInput.zip_code" name="zip_code" rules="required"></v-input>
      </div>
      <div class="w-full md:w-1/2 px-2 mb-6">
        <div class="mb-2">Land: *</div>
        <countryselect v-model="agencyInput.country"></countryselect>
      </div>
      <div class="w-1/2 px-2 mb-6">
        <div class="mb-2">Umsatzsteuer Identifikationsnummer: *</div>

        <v-input v-model="agencyInput.tax_number" name="tax_number" rules="required"></v-input>
      </div>
    </div>

    <div
      v-if="!!agencyInput.legal_accepted_at"
      class="text-gray-700"
    >AGBs akzeptiert am {{legalAcceptedAt}} Uhr</div>

    <button
      class="btn btn-primary mt-8"
      :class="{'btn-loading': loading}"
      @click="patch"
      :disabled="errors.count() > 0 || loading"
    >Speichern</button>
  </div>
</template>

<script>
import accountClient from "@/api/merchant/account";
import Countryselect from "@/components/Countryselect";
import dayjs from "dayjs";

export default {
  props: ["agency"],
  components: {
    Countryselect
  },

  data() {
    return {
      loading: false,
      agencyInput: {}
    };
  },

  watch: {
    agency: {
      handler() {
        this.agencyInput = JSON.parse(JSON.stringify(this.agency));
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
    legalAcceptedAt() {
      return dayjs(this.agency.legal_accepted_at).format("DD.MM.YYYY HH:mm");
    }
  },

  methods: {
    patch() {
      this.validateAll().then(state => {
        if (state) {
          this.loading = true;
          accountClient
            .patch(this.agencyInput)
            .then(() => {
              this.$emit("saved");
              this.$store.dispatch("account/getCurrentAccount");
              this.$store.dispatch("account/getAccountsByUser");
              this.$toasted.global.saved();
            })
            .catch(() => this.$toasted.global.error())
            .then(() => (this.loading = false));
        }
      });
    },

    validateAll() {
      return this.$validator.validateAll();
    }
  }
};
</script>
